"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth0Provider = exports.useAuth0 = exports.Auth0Context = void 0;
const react_1 = __importStar(require("react"));
const auth0_spa_js_1 = __importDefault(require("@auth0/auth0-spa-js"));
exports.Auth0Context = react_1.default.createContext({});
exports.useAuth0 = () => react_1.useContext(exports.Auth0Context);
exports.Auth0Provider = ({ children, onRedirectCallback, domain = 'auth.cmrclaims.com', redirect_uri = window.location.origin, audience = 'https://api.cmrclaims.com', history, autoLoginRedirect, ...initOptions }) => {
    const [isAuthenticated, setIsAuthenticated] = react_1.useState(false);
    const [user, setUser] = react_1.useState();
    const [auth0Client, setAuth0] = react_1.useState();
    const [loading, setLoading] = react_1.useState(true);
    const [popupOpen, setPopupOpen] = react_1.useState(false);
    const [unauthorized, setUnauthorized] = react_1.useState(false);
    react_1.useEffect(() => {
        const initAuth0 = async () => {
            const auth0FromHook = await auth0_spa_js_1.default({ ...initOptions, domain, redirect_uri, audience });
            setAuth0(auth0FromHook);
            if (window.location.search.includes('code=')) {
                const { appState } = await auth0FromHook.handleRedirectCallback();
                if (!onRedirectCallback) {
                    if (history) {
                        history.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
                    }
                    else {
                        window.history.replaceState({}, document.title, window.location.pathname);
                    }
                }
                else {
                    onRedirectCallback(appState);
                }
            }
            if (window.location.search.includes('error=unauthorized')) {
                setUnauthorized(true);
            }
            const isAuthenticated = await auth0FromHook.isAuthenticated();
            setIsAuthenticated(isAuthenticated);
            if (isAuthenticated) {
                const user = await auth0FromHook.getUser();
                setUser(user);
            }
            setLoading(false);
        };
        initAuth0();
        // eslint-disable-next-line
    }, []);
    const loginWithPopup = async (o) => {
        setPopupOpen(true);
        try {
            await auth0Client.loginWithPopup(o);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setPopupOpen(false);
        }
        const user = await auth0Client.getUser();
        setUser(user);
        setIsAuthenticated(true);
    };
    const handleRedirectCallback = async () => {
        setLoading(true);
        const result = await auth0Client.handleRedirectCallback();
        const user = await auth0Client.getUser();
        setLoading(false);
        setIsAuthenticated(true);
        setUser(user);
        return result;
    };
    const hasPermission = (permission) => user &&
        user['http://cmrclaims.com/claims/permissions'] &&
        user['http://cmrclaims.com/claims/permissions'].includes(permission);
    if (!isAuthenticated && !loading && auth0Client && autoLoginRedirect) {
        auth0Client.loginWithRedirect({});
    }
    return (react_1.default.createElement(exports.Auth0Context.Provider, { value: {
            isAuthenticated,
            hasPermission,
            user,
            loading,
            popupOpen,
            loginWithPopup,
            handleRedirectCallback,
            unauthorized,
            getIdTokenClaims: (o) => auth0Client.getIdTokenClaims(o),
            loginWithRedirect: (o) => auth0Client.loginWithRedirect(o),
            getTokenSilently: (o) => auth0Client.getTokenSilently(o),
            getTokenWithPopup: (o) => auth0Client.getTokenWithPopup(o),
            logout: (o) => auth0Client.logout(o),
        } }, children));
};
//# sourceMappingURL=auth0.js.map